import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Key, KeyboardRow } from './keyboard.types';
import { KeyComponent } from './key.component';

@Component({
  selector: 'lib-keyboard',
  imports: [KeyComponent],
  templateUrl: './keyboard.component.html',
})
export class KeyboardComponent {
  @Input({ required: true }) public rows!: KeyboardRow[];

  @Input() public disabled = false;

  @Output() public readonly keyPress = new EventEmitter<Key>();
}
